var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", {}, [
      _c("strong", [_vm._v("Ultimo conceito: ")]),
      _vm._v(_vm._s(_vm.opinion != null ? _vm.opinion.grade : ""))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }